import { Link } from "react-router-dom";
import { img, srcSet, altOf, nameOf } from "@/lib/media";
import { useLang } from "@/lib/i18n";
import { Reveal } from "./Reveal";

export const Themes = ({ themes }) => {
  const { t, lang } = useLang();
  return (
    <section className="alt" id="themes" data-testid="themes-section">
      <div className="wrap">
        <Reveal>
          <h2>{t.themes.h}</h2>
          <p className="lede">
            {t.themes.lede}{" "}
            <Link className="text-link text-link-sm" to="/gallery" data-testid="themes-view-gallery-link">{t.themes.all}</Link>
          </p>
        </Reveal>
        <div className="tiles">
          {themes.map((th, i) => (
            <Reveal key={th.id} delay={i * 0.05}>
              <Link className="tile" to={`/gallery?theme=${th.id}`} data-testid={`theme-tile-${th.id}`}>
                <img alt={altOf(th.cover, lang)} loading="lazy" src={img(th.cover.file, 480)} srcSet={srcSet(th.cover.file)}
                  sizes="(max-width:640px) 50vw, (max-width:900px) 33vw, 190px" />
                <span>{nameOf(th, lang)}</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
